import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { formatNumber } from '../../../lib/ep.js';

const QuizGameResult = (props) => {
	const user = props.user;

	return (
		<div>
			<ul class="user_participations_info">
				<li class="knk-goal hb_mainFontWeightRoman">
					<FormattedMessage
						id={"Score: {score} points"}
						values={{score:formatNumber(user.quiz_result)}}
					/>
				</li>

				<li class="knk-loading hb_mainFontWeightRoman">
					<FormattedMessage
						id={"Time: {time} seconds"}
						values={{time:formatNumber(user.time)}}
					/>
				</li>
			</ul>
		</div>
	)
};

export default injectIntl(QuizGameResult);